<div *ngIf="loading" class="loading">Caricamento dati...</div>
<div *ngIf="!loading">
  <!-- Grafico -->
  <div class="chart-container">
    <div echarts [options]="chartOptions" class="full-width"></div>
  </div>
  <div class="date-labels-container">
    <div class="date-label" *ngFor="let date of dateHeaders">
      {{ date }}
    </div>
  </div>
  
</div>
